import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  UilArchive,
  UilImage,
  UilMusic,
  UilVideo,
  UilStar
} from '@iconscout/react-unicons';
// import team60 from 'assets/img/team/60.webp';
// import team58 from 'assets/img/team/58.webp';
// import team57 from 'assets/img/team/57.webp';
// import team59 from 'assets/img/team/59.webp';
// import team30 from 'assets/img/team/30.webp';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export interface SidebarItem {
  icon: JSX.Element;
  label: string;
  count?: number;
  link?: string;
  active?: boolean;
}

// export interface PitchDeck {
//   id: number;
//   sender: {
//     name: string;
//     avatar?: string;
//   };
//   subject: string;
//   details: string;
//   time: string;
//   starred: boolean;
//   read_at: Date | null;
//   attachments?: {
//     id: number;
//     format: string;
//     fileName: string;
//   }[];
// }
export const mailboxItems: SidebarItem[] = [
  {
    icon: <UilImage size={12} />,
    label: 'Images',
    count: 5,
    active: true,
    link: `/apps/images/browse-images/`
  },
  {
    icon: <UilVideo size={12} />,
    label: 'Video',
    count: 23,
    active: false,
    link: `/apps/images/browse-video/`
  },
  {
    icon: <UilMusic size={12} />,
    label: 'Audio',
    count: 24,
    active: false,
    link: `/apps/images/browse-audio/`
  }
];

export const filteredItems: SidebarItem[] = [
  {
    icon: <UilStar size={12} />,
    label: 'Starred'
  },
  {
    icon: <UilArchive size={12} />,
    label: 'Archive'
  }
];

export const labelItems: SidebarItem[] = [
  {
    icon: (
      <FontAwesomeIcon
        icon={faCircle}
        className="text-primary ms-n1"
        transform="shrink-10"
      />
    ),
    label: 'Sora'
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faCircle}
        className="text-primary-600 ms-n1"
        transform="shrink-10"
      />
    ),
    label: 'ChatGPT'
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faCircle}
        className="text-success ms-n1"
        transform="shrink-10"
      />
    ),
    label: 'Gemini'
  }
  //,
  // {
  //   icon: (
  //     <FontAwesomeIcon
  //       icon={faCircle}
  //       className="text-warning ms-n1"
  //       transform="shrink-10"
  //     />
  //   ),
  //   label: 'Invoices'
  // },
  // {
  //   icon: (
  //     <FontAwesomeIcon
  //       icon={faCircle}
  //       className="text-danger ms-n1"
  //       transform="shrink-10"
  //     />
  //   ),
  //   label: 'Accounts'
  // },
  // {
  //   icon: (
  //     <FontAwesomeIcon
  //       icon={faCircle}
  //       className="text-info ms-n1"
  //       transform="shrink-10"
  //     />
  //   ),
  //   label: 'Forums'
  // }
];
